import { LOCALES } from 'i18n/locales';

export const signOutIntl = {
    [LOCALES.ENGLISH]: {
        'signOut.title': 'Are you sure you want to sign out?',

        'signOut.button.agree': 'Confirm Logout ',
        'signOut.button.agree.ariaLabel': 'Confirm Logout Button',

        'signOut.button.disagree': 'Cancel Logout ',
        'signOut.button.disagree.ariaLabel': 'Cancel Logout Button'

    },
    [LOCALES.WELSH]: {
        'signOut.title': 'Ydych chi\'n siŵr fod eisiau allgofnodi arnoch?',

        'signOut.button.agree': 'Cadarnhau Allgofnodi ',
        'signOut.button.agree.ariaLabel': 'Botwm Cadarnhau Allgofnodi',

        'signOut.button.disagree': 'Canslo Allgofnodi ',
        'signOut.button.disagree.ariaLabel': 'Botwm Canslo Allgofnodi'
    }
};
